module.exports = __webpack_public_path__ + "img/discount-arrow.3736d4d.png";